var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEmail, IsOptional, IsString, MaxLength, MinLength } from 'class-validator';
//  👉 POST /public/ui/leads
export class LeadCreateRequest {
}
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], LeadCreateRequest.prototype, "landingName", void 0);
__decorate([
    IsString(),
    MinLength(2),
    MaxLength(255),
    __metadata("design:type", String)
], LeadCreateRequest.prototype, "clientName", void 0);
__decorate([
    IsString(),
    MinLength(2),
    MaxLength(255),
    __metadata("design:type", String)
], LeadCreateRequest.prototype, "companyName", void 0);
__decorate([
    MaxLength(255),
    MinLength(2),
    IsEmail(),
    __metadata("design:type", String)
], LeadCreateRequest.prototype, "contactEmail", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], LeadCreateRequest.prototype, "createPipedriveLead", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], LeadCreateRequest.prototype, "isMql", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], LeadCreateRequest.prototype, "isSubscribeToNewsletter", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], LeadCreateRequest.prototype, "recaptchaToken", void 0);
//# sourceMappingURL=lead-create.request.js.map